import { Outlet } from "react-router-dom";

import Navigation from "../../../../components/navigations/provider-management/detail/navigation";
import useParentLoaderData from "../../../../hooks/useParentLoaderData";

export default function Template() {
  const { id } = useParentLoaderData(2);
  return (
    <Navigation activeTab="location-info" providerId={id}>
      <div className="flex h-full min-h-0 flex-1 flex-col overflow-y-auto rounded-b-[15px] bg-white [&::-webkit-scrollbar-thumb]:bg-blue-700 [&::-webkit-scrollbar]:[width:6px]">
        <Outlet />
      </div>
    </Navigation>
  );
}
